// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addNewItemsStyles } from "@conklin/App/Components/MyListsDetails/AddNewItems";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

const actionsSharedStyles = {
    css: css`
        &&&& {
            max-width: unset;
            flex-basis: unset;
            padding-top: 3px;
        }
    `,
};

addNewItemsStyles.orderUploadGridItem = {
    width: [12, 12, 6, 6, 6],
};

addNewItemsStyles.uploadInstructionsGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        padding-left: 20px;
    `,
};

addNewItemsStyles.actionButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
    `,
};

addNewItemsStyles.productSelectorModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalContent: css`
            display: flex;
            flex-direction: column;
        `,
    },
};

addNewItemsStyles.actionsWrapper = {
    css: css`
        display: flex;
        margin-top: 20px;
        justify-content: end;
        gap: 15px;
    `,
};

addNewItemsStyles.sectionHeader = {
    variant: "h5",
    css: css`
        margin-bottom: 8px;
    `,
};

addNewItemsStyles.sectionText = {
    size: 14,
    css: css`
        margin-bottom: 12px;
        line-height: 22px;
    `,
};

addNewItemsStyles.productSelectorStyles = {
    container: {
        offsetCss: css`
            justify-content: flex-end;
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
            &&& {
                margin-bottom: 12px;
            }
        `,
    },
    searchGridItem: {
        width: 12,
        css: css`
            flex-basis: 100%;
            max-width: 100%;
        `,
    },
    qtyGridItem: actionsSharedStyles,
    unitOfMeasureGridItem: actionsSharedStyles,
    buttonGridItem: {
        css: css`
            &&&& {
                max-width: unset;
                flex-basis: unset;
                padding-top: 0;
                ${xScreen("lte", "md")} {
                    padding-right: 10px;
                }
            }
        `,
    },
};

addNewItemsStyles.actionsWrapper = {
    css: css`
        justify-content: flex-start;
    `,
};

addNewItemsStyles.uploadItemsButton = { variant: "secondary" };
